import React from "react";

import chroma from "chroma-js";
import classNames from "classnames";
import { renderToStaticMarkup } from "react-dom/server";

import ContentTooltipSchedule from "./ContentTooltipSchedule";
import { getBlackOrWhiteColorByContrast } from "../../../utils/colors";

import type { JSX, MutableRefObject } from "react";

import type { GroupTimeline, TimelineRef } from "./timeline.types";

interface GroupRendererProps {
  group: GroupTimeline;
  handleClick: (scheduleId: string) => void;
  timelineRef: MutableRefObject<TimelineRef | null>;
}

function GroupRenderer({
  group,
  handleClick,
  timelineRef,
}: GroupRendererProps): JSX.Element {
  const { color, isActive, scheduleId, title, framerate, broadcasts } = group;
  const isVerticalTimeline = timelineRef?.current?.props.isVertical;

  const containerClassNames = classNames(
    "flex size-full cursor-pointer",
    isVerticalTimeline
      ? "border-x-4 border-b-4 rounded-b-lg"
      : "rounded-r-lg border-y-4 border-r-4",
  );

  const labelClassNames = classNames(
    "flex size-full items-center justify-center py-[0.46875rem] leading-9",
    isVerticalTimeline ? "" : " -rotate-180 [writing-mode:vertical-lr]",
  );

  return (
    <div
      className={containerClassNames}
      data-tooltip-id="timeline-tooltip"
      data-tooltip-place="right"
      onClick={(): void => handleClick(scheduleId)}
      data-tooltip-html={renderToStaticMarkup(
        <ContentTooltipSchedule
          broadcasts={broadcasts}
          framerate={framerate}
          title={title}
        />,
      )}
      style={{
        backgroundColor: isActive ? color : "var(--card)",
        borderColor: !isActive ? chroma(color).hex() : "transparent",
        color: isActive
          ? getBlackOrWhiteColorByContrast(color)
          : "var(--foreground)",
      }}
    >
      <div className={labelClassNames}>
        <span className="truncate font-semibold">{title}</span>
      </div>
    </div>
  );
}

export default GroupRenderer;
